<template>
  <div>
    <app-header title="Customer List">
      <b-button variant="primary" @click="exportCustomersXLS()">
        Download
      </b-button>
    </app-header>
    <loading-spinner v-if="!customers" />
    <b-container v-else>
      <b-row>
        <b-col>
          <b-tabs>
            <b-tab title="Customers" class="mt-4" active>
              <h3>All Customers</h3>
              <b-button
                variant="outline-primary"
                class="mb-2 mr-2"
                @click="exportCustomers()"
              >
                Download CSV
              </b-button>
              <b-button
                variant="outline-primary"
                class="mb-2"
                @click="exportCustomersXLS()"
              >
                Download XLSX
              </b-button>
              <b-table-simple striped>
                <b-thead>
                  <b-tr>
                    <b-th>ID</b-th>
                    <b-th>Created</b-th>
                    <b-th>First Name</b-th>
                    <b-th>Last Name</b-th>
                    <b-th>Phone</b-th>
                    <b-th>Email</b-th>
                    <b-th>Month and year</b-th>
                    <b-th>Country</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="customer in customers" :key="customer.id">
                    <b-td>{{ customer.id }}</b-td>
                    <b-td>{{ customer.created | moment("YYYY-MM-DD") }}</b-td>
                    <b-td>{{ customer.first_name }}</b-td>
                    <b-td>{{ customer.last_name }}</b-td>
                    <b-td>{{ customer.phonenumber }}</b-td>
                    <b-td>{{ customer.email }}</b-td>
                    <b-td>{{ customer.month }} {{ customer.year }}</b-td>
                    <b-td>{{ customer.country }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-tab>
            <b-tab title="Countries" class="mt-4">
              <h3>Countries</h3>
              <b-button
                variant="outline-primary"
                class="mb-2"
                @click="exportCountries()"
              >
                Download CSV
              </b-button>
              <b-table-simple striped>
                <b-thead>
                  <b-tr>
                    <b-th>Country</b-th>
                    <b-th>Count</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="country in countries" :key="country.country">
                    <b-td>{{ country.country }}</b-td>
                    <b-td>{{ country.count }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-tab>
            <b-tab title="Months" class="mt-4">
              <h3>Join Month</h3>
              <b-button
                variant="outline-primary"
                class="mb-2"
                @click="exportMonths()"
              >
                Download CSV
              </b-button>
              <b-table-simple striped>
                <b-thead>
                  <b-tr>
                    <b-th>Month</b-th>
                    <b-th>Count</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="month in months" :key="month.month">
                    <b-td>{{ month.month }}</b-td>
                    <b-td>{{ month.count }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-tab>
            <b-tab title="Months and Years" class="mt-4">
              <h3>Join Month and Years</h3>
              <b-button
                variant="outline-primary"
                class="mb-2"
                @click="exportMonthsandYears()"
              >
                Download CSV
              </b-button>
              <b-table-simple striped>
                <b-thead>
                  <b-tr>
                    <b-th>Month & Year</b-th>
                    <b-th>Count</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="my in monthyear" :key="my.month">
                    <b-td>{{ my.monthyear }}</b-td>
                    <b-td>{{ my.count }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from "@/services/api";
import $csv from "@/services/csv";
import AppHeader from "@/components/AppHeader";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  components: {
    AppHeader,
    LoadingSpinner,
  },

  data() {
    return {
      customers: null,
      monyear: null
    };
  },

  computed: {
    countries() {
      /* eslint-disable */
      const countries = {};
      this.customers &&
        this.customers.forEach((customer) => {
          countries[customer.country] = countries[customer.country] || 0;
          countries[customer.country] = countries[customer.country] + 1;
        });
      return Object.keys(countries).map((country) => ({
        country,
        count: countries[country],
      }));
    },

    months() {
      /* eslint-disable */
      const months = {};
      this.customers &&
        this.customers.forEach((customer) => {
          months[customer.month] = months[customer.month] || 0;
          months[customer.month] = months[customer.month] + 1;
        });
      return Object.keys(months).map((month) => ({
        month,
        count: months[month],
      }));
    },
    monthyear(){
      const monthyears = {};
      this.monyear &&
        this.monyear.forEach((customer) => {
          monthyears[customer.monthyear] = monthyears[customer.monthyear] || 0;
          monthyears[customer.monthyear] = monthyears[customer.monthyear] + 1;
        });
      return Object.keys(monthyears).map((monthyear) => ({
        monthyear,
        count: monthyears[monthyear],
      }));
    }
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.customers = await $api.get("/v1/internal/customers");
      this.monyear = this.customers.map((item) => ({
        ...item,
        "monthyear": item.month + " " + item.year,
      }));
    },

    exportCustomers() {
      const customersNew = this.customers.map((item) => ({
        ...item,
        "month and year": item.month + " " + item.year,
      }));
      $csv.export(
        customersNew,
        [
          "id",
          "created",
          "first_name",
          "last_name",
          "phonenumber",
          "email",
          "month and year",
          "country",
        ],
        "customers.csv"
      );
    },

    exportCustomersXLS() {
      /* eslint-disable */
      const wb = XLSX.utils.book_new();
      const data = [
        [
          "id",
          "created",
          "first_name",
          "last_name",
          "phonenumber",
          "email",
          "month & year",
          "country",
        ],
      ];
      this.customers.forEach((customer) => {
        data.push([
          customer.id,
          customer.created,
          customer.first_name,
          customer.last_name,
          customer.phonenumber,
          customer.email,
          customer.month + " " + customer.year,
          customer.country,
        ]);
      });
      const ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Customers");
      XLSX.writeFile(wb, "customers.xlsx");
    },

    exportCountries() {
      $csv.export(this.countries, ["country", "count"], "countries.csv");
    },

    exportMonths() {
      $csv.export(this.months, ["month", "count"], "months.csv");
    },
    exportMonthsandYears(){
      $csv.export(this.monthyear, ["monthyear", "count"], "monthsandyears.csv");
    }
  },
};
</script>
